import { render, staticRenderFns } from "./Rule_TK-3cards.vue?vue&type=template&id=c2915d62&"
import script from "./Rule_TK-3cards.vue?vue&type=script&lang=js&"
export * from "./Rule_TK-3cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports